import { AlertOctagon } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const downtimeNav: NavEntry = {
  label: 'Downtime',
  icon: AlertOctagon,
  path: '/downtime',
  permission: 'downtime:read',
  order: 19,
}
